import { editorLocalization } from "survey-creator-core";

export var msStrings = {
  survey: {
    edit: "Edit",
    externalHelpLink: "Tonton dan belajar cara mencipta tinjauan",
    externalHelpLinkUrl: "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber",
    dropQuestion: "Sila letakkan soalan di sini daripada Kotak Alat",
    addLogicItem: "Cipta peraturan untuk menyesuaikan aliran tinjauan.",
    copy: "Salin",
    duplicate: "Pendua",
    addToToolbox: "Tambahkan kepada kotak alat",
    deletePanel: "Padamkan Panel",
    deleteQuestion: "Padamkan Soalan",
    convertTo: "Tukar kepada",
    drag: "Seret unsur"
  },
  qt: {
    default: "Lalai",
    checkbox: "Kotak semak",
    comment: "Komen",
    imagepicker: "Pemilih imej",
    ranking: "Kedudukan",
    image: "Imej",
    dropdown: "Juntai bawah",
    file: "Fail",
    html: "HTML",
    matrix: "Matriks (pilihan tunggal)",
    matrixdropdown: "Matriks (pilihan berbilang)",
    matrixdynamic: "Matriks (baris dinamik)",
    multipletext: "Teks Berbilang",
    panel: "Panel",
    paneldynamic: "Panel (panel dinamik)",
    radiogroup: "Kumpulan radio",
    rating: "Penarafan",
    text: "Input Tunggal",
    boolean: "Boolean",
    expression: "Ekspresi (baca sahaja)",
    signaturepad: "Pad tandatangan",
    flowpanel: "Panel Aliran"
  },
  ed: {
    defaultLocale: "Lalai ({0})",
    survey: "Tinjauan",
    settings: "Tetapan Tinjauan",
    settingsTooltip: "Buka tetapan tinjauan",
    showPanel: "Tunjukkan Panel",
    hidePanel: "Sembunyikan Panel",
    addNewPage: "Tambahkan Halaman Baharu",
    moveRight: "Tatal ke Kanan",
    moveLeft: "Tatal ke Kiri",
    deletePage: "Padamkan Halaman",
    editPage: "Edit Halaman",
    edit: "Edit",
    newPageName: "halaman",
    newQuestionName: "soalan",
    newPanelName: "panel",
    newTextItemName: "teks",
    testSurvey: "Uji Tinjauan",
    testSurveyAgain: "Uji Tinjauan Semula",
    testSurveyWidth: "Lebar tinjauan: ",
    navigateToMsg: "Anda perlu navigasi ke:",
    logic: "Logik Tinjauan",
    embedSurvey: "Benamkan Tinjauan",
    translation: "Terjemahan",
    saveSurvey: "Simpan Tinjauan",
    saveSurveyTooltip: "Simpan Tinjauan",
    designer: "Pereka Bentuk Tinjauan",
    jsonEditor: "Editor JSON",
    undo: "Buat Asal",
    redo: "Buat Semula",
    undoTooltip: "Buat asal perubahan terakhir",
    redoTooltip: "Buat semula perubahan",
    copy: "Salin",
    cut: "Potong",
    paste: "Tampal",
    copyTooltip: "Salin pilihan kepada papan klip",
    cutTooltip: "Potong pilihan kepada papan klip",
    pasteTooltip: "Tampal daripada papan klip",
    options: "Pilihan",
    generateValidJSON: "Jana JSON yang Sah",
    generateReadableJSON: "Jana JSON yang Boleh Dibaca",
    toolbox: "Kotak Alat",
    "property-grid": "Ciri",
    toolboxGeneralCategory: "Umum",
    correctJSON: "Pilih JSON yang betul.",
    surveyResults: "Keputusan Tinjauan: ",
    surveyResultsTable: "Sebagai Jadual",
    surveyResultsJson: "Sebagai JSON",
    resultsTitle: "Tajuk Soalan",
    resultsName: "Nama Soalan",
    resultsValue: "Nilai Jawapan",
    resultsDisplayValue: "Nilai Paparan",
    modified: "Diubah suai",
    saving: "Menyimpan",
    saved: "Disimpan",
    propertyEditorError: "Ralat:",
    saveError: "Ralat! Kandungan editor tidak disimpan.",
    translationAddLanguage: "Pilihan bahasa untuk diterjemah",
    translationShowAllStrings: "Tunjukkan semua rentetan",
    translationShowAllPages: "Tunjukkan semua halaman",
    translationNoStrings: "Tiada rentetan untuk diterjemah. Sila ubah penapis.",
    translationExportToSCVButton: "Eksport kepada CSV",
    translationImportFromSCVButton: "Import daripada CSV",
    translationMergeLocaleWithDefault: "Gabung {0} dengan tempatan lalai",
    bold: "Tebal",
    italic: "Condong",
    underline: "Garis bawah",
    addNewQuestion: "Tambahkan soalan",
    selectPage: "Pilih halaman...",
    lg: {
      addNewItem: "",
      page_visibilityName: "Kebolehlihatan halaman",
      panel_visibilityName: "Kebolehlihatan panel",
      panel_enableName: "Dayakan/Lumpuhkan panel",
      question_visibilityName: "Kebolehlihatan soalan",
      question_enableName: "Dayakan/Lumpuhkan soalan",
      question_requireName: "Pilihan soalan diperlukan",
      trigger_completeName: "Lengkapkan tinjauan",
      trigger_setvalueName: "Tetapkan nilai soalan",
      trigger_copyvalueName: "Salin nilai soalan",
      trigger_skipName: "Langkau kepada soalan",
      trigger_runExpressionName: "Jalankan ekspresi tersuai",
      completedHtmlOnConditionName: "Teks 'Halaman terima kasih' tersuai",
      page_visibilityDescription: "Jadikan halaman boleh dilihat apabila ekspresi logik mengembalikan nilai benar. Jika tidak, biarkan tersembunyi.",
      panel_visibilityDescription: "Jadikan panel boleh dilihat apabila ekspresi logik mengembalikan nilai benar. Jika tidak, biarkan tersembunyi.",
      panel_enableDescription: "Jadikan panel dan semua elemen dalamnya didayakan apabila ekspresi logik mengembalikan nilai benar. Jika tidak, biarkan lumpuh.",
      question_visibilityDescription: "Jadikan soalan boleh dilihat apabila ekspresi logik mengembalikan nilai benar. Jika tidak, biarkan tersembunyi.",
      question_enableDescription: "Jadikan soalan didayakan apabila ekspresi logik mengembalikan nilai benar. Jika tidak, biarkan lumpuh.",
      question_requireDescription: "Soalan diperlukan apabila ekspresi logik mengembalikan nilai benar.",
      trigger_completeDescription: "Apabila ekspresi logik mengembalikan nilai benar, maka tinjauan akan lengkap dan pengguna akhir akan melihat 'Halaman terima kasih'.",
      trigger_setvalueDescription: "Apabila nilai soalan, yang digunakan dalam ekspresi logik, berubah dan ekspresi logik mengembalikan nilai benar, maka nilai ditetapkan kepada soalan yang dipilih.",
      trigger_copyvalueDescription: "Apabila nilai soalan, yang digunakan dalam ekspresi logik, berubah dan ekspresi logik mengembalikan nilai benar, maka nilai salah satu soalan yang dipilih akan disalin kepada satu lagi soalan yang dipilih.",
      trigger_skipDescription: "Apabila ekspresi logik mengembalikan nilai benar, maka tinjauan melangkau kepada / fokus pada soalan yang dipilih.",
      trigger_runExpressionDescription: "Apabila ekspresi mengembalikan nilai benar, maka ekspresi tersuai akan dilaksanakan. Anda boleh menetapkan keputusan ekspresi ini kepada soalan yang dipilih secara pilihan",
      completedHtmlOnConditionDescription: "Apabila ekspresi logik mengembalikan nilai benar, maka teks lalai untuk 'Halaman terima kasih' berubah kepada teks yang diberikan.",
      itemExpressionText: "Apabila ekspresi: '{0}' mengembalikan nilai benar:",
      page_visibilityText: "Jadikan halaman {0} boleh dilihat",
      panel_visibilityText: "Jadikan panel {0} boleh dilihat",
      panel_enableText: "Jadikan panel {0} didayakan",
      question_visibilityText: "Jadikan soalan {0} boleh dilihat",
      question_enableText: "Jadikan soalan {0} didayakan",
      question_requireText: "Jadikan soalan {0} diperlukan",
      trigger_completeText: "Tinjauan dilengkapkan",
      trigger_setvalueText: "Tetapkan kepada soalan: {0} nilai {1}",
      trigger_copyvalueText: "Salin kepada soalan: {0} nilai daripada soalan {1}",
      trigger_skipText: "Tinjauan melangkau ke soalan {0}",
      trigger_runExpressionText1: "Jalankan ekspresi: '{0}'",
      trigger_runExpressionText2: " dan tetapkan keputusannya kepada soalan: {0}",
      completedHtmlOnConditionText: "Tunjukkan teks tersuai untuk 'Halaman terima kasih'.",
      conditions: "Syarat",
      actions: "Tindakan",
      expressionEditorTitle: "Takrifkan syarat",
      actionsEditorTitle: "Takrifkan tindakan",
      deleteAction: "Padamkan tindakan",
      addNewAction: "Tambahkan tindakan baharu",
      selectedActionCaption: "Pilih tindakan untuk ditambahkan...",
      expressionInvalid: "Ekspresi logik kosong atau tidak sah. Sila betulkannya.",
      noActionError: "Sila tambahkan sekurang-kurangnya satu tindakan.",
      actionInvalid: "Sila baiki masalah dalam tindakan anda.",
      expressionSetup: "",
      actionsSetup: ""
    }
  },
  pe: {
    apply: "Guna",
    ok: "OK",
    save: "Simpan",
    saveTooltip: "Simpan",
    cancel: "Batal",
    reset: "Tetap Semula",
    refresh: "Segar semula",
    delete: "Padam",
    add: "Tambahkan",
    addNew: "Tambah Baharu",
    addItem: "Klik untuk menambahkan item...",
    addOther: "Lain-lain",
    addSelectAll: "Pilih Semua",
    addNone: "Tiada",
    removeAll: "Alih Keluar Semua",
    edit: "Edit",
    view: "Lihat",
    back: "Kembali tanpa menyimpan",
    backTooltip: "Kembali tanpa menyimpan",
    saveAndBack: "Simpan dan kembali",
    saveAndBackTooltip: "Simpan dan kembali",
    editChoices: "Edit Pilihan",
    showChoices: "Tunjukkan Pilihan",
    move: "Alih",
    empty: "<empty>",
    fastEntry: "Entri Pantas",
    formEntry: "Entri Borang",
    testService: "Uji perkhidmatan",
    itemSelectorEmpty: "Sila pilih elemen",
    conditionActionEmpty: "Sila pilih tindakan",
    conditionSelectQuestion: "Pilih soalan...",
    conditionSelectPage: "Pilih halaman...",
    conditionSelectPanel: "Pilih panel...",
    conditionValueQuestionTitle: "Sila masukkan/pilih nilai",
    expressionHelp: "Anda boleh gunakan kurungan kerinting untuk mengakses nilai soalan: {soalan1} + {soalan2}, ({harga}*{kuantiti}) * (100 - {diskaun}). Anda boleh menggunakan fungsi seperti: iif(), today(), age(), min(), max(), count(), avg() dan lain-lain.",
    aceEditorHelp: "Tekan ctrl+space untuk mendapatkan petunjuk lengkapan ekspresi",
    aceEditorRowTitle: "Baris semasa",
    aceEditorPanelTitle: "Panel semasa",
    showMore: "Untuk butiran lanjut, sila semak dokumentasi",
    assistantTitle: "Soalan tersedia:",
    cellsEmptyRowsColumns: "Terdapat sekurang-kurangnya satu lajur atau baris",
    propertyIsEmpty: "Sila masukkan nilai",
    propertyIsNoUnique: "Sila masukkan nilai unik",
    propertyNameIsNotUnique: "Sila masukkan nama unik",
    listIsEmpty: "Tambahkan item baharu",
    expressionIsEmpty: "Ekspresi kosong",
    value: "Nilai",
    text: "Teks",
    rowid: "ID Baris",
    imageLink: "Pautan Imej",
    columnEdit: "Edit lajur: {0}",
    itemEdit: "Edit item: {0}",
    itemView: "Lihat item: {0}",
    url: "URL",
    path: "Laluan",
    valueName: "Nama nilai",
    titleName: "Nama tajuk",
    allowEmptyResponse: "Benarkan respons kosong",
    titlePlaceholder: "Tajuk input di sini",
    surveyTitlePlaceholder: "Tajuk tinjauan input di sini",
    pageTitlePlaceholder: "Tajuk halaman input di sini",
    descriptionPlaceholder: "Masukkan perihalan",
    surveyDescriptionPlaceholder: "Masukkan perihalan tinjauan",
    pageDescriptionPlaceholder: "Masukkan perihalan halaman",
    showOtherItem: "Ada item lain",
    otherText: "Teks item lain",
    showNoneItem: "Tiada item",
    noneText: "Tiada teks item",
    showSelectAllItem: "Telah pilih semua item",
    selectAllText: "Pilih semua teks item",
    choicesMin: "Nilai minimum untuk item auto dijana",
    choicesMax: "Nilai maksimum untuk item auto dijana",
    choicesStep: "Perbezaan antara item auto dijana",
    name: "Nama",
    title: "Tajuk",
    cellType: "Jenis sel",
    colCount: "Kiraan lajur",
    choicesOrder: "Pilih susunan pilihan",
    visible: "Boleh dilihat?",
    isRequired: "Diperlukan?",
    isAllRowRequired: "Perlukan jawapan untuk semua baris",
    requiredErrorText: "Teks ralat diperlukan",
    startWithNewLine: "Mulakan dengan baris baharu?",
    rows: "Kiraan baris",
    cols: "Kiraan lajur",
    placeholder: "Ruang letak input",
    showPreview: "Tunjukkan kawasan pratonton",
    storeDataAsText: "Simpan kandungan fail dalam keputusan JSON sebagai teks",
    maxSize: "Maksimum saiz fail dalam bait",
    imageHeight: "Tinggi imej",
    imageWidth: "Lebar imej",
    rowCount: "Kiraan baris",
    columnLayout: "Tataletak lajur",
    addRowLocation: "Tambahkan lokasi butang baris",
    addRowText: "Tambahkan teks butang baris",
    removeRowText: "Alih keluar teks butang baris",
    rateMin: "Kadar minimum",
    rateMax: "Kadar maksimum",
    rateStep: "Langkah kadar",
    minRateDescription: "Perihalan kadar minimum",
    maxRateDescription: "Perihalan kadar maksimum",
    inputType: "Jenis input",
    optionsCaption: "Kapsyen pilihan",
    showOptionsCaption: "Tunjukkan kapsyen pilihan",
    defaultValue: "Nilai lalai",
    cellsDefaultRow: "Teks sel lalai",
    surveyEditorTitle: "Edit tetapan tinjauan",
    qEditorTitle: "Edit: {0}",
    maxLength: "Panjang maksimum",
    buildExpression: "Bina",
    editExpression: "Edit",
    and: "Dan",
    or: "Atau",
    remove: "Alih keluar",
    addCondition: "Tambahkan syarat",
    showTitle: "Tunjukkan/sembunyikan tajuk",
    expandCollapseTitle: "Kembangkan/runtuhkan tajuk",
    locale: "Bahasa lalai",
    simulator: "Pilih peranti",
    landscapeOrientation: "Landskap",
    mode: "Mod (edit/baca sahaja)",
    clearInvisibleValues: "Kosongkan nilai tersembunyi",
    cookieName: "Nama kuki (untuk melumpuhkan perlaksanaan tinjauan dua kali secara setempat)",
    sendResultOnPageNext: "Hantar keputusan tinjauan pada halaman seterusnya",
    storeOthersAsComment: "Simpan nilai 'lain-lain' dalam medan berasingan",
    showPageTitles: "Tunjukkan tajuk halaman",
    showPageNumbers: "Tunjukkan nombor halaman",
    pagePrevText: "Teks butang halaman sebelumnya",
    pageNextText: "Teks butang halaman seterusnya",
    completeText: "Teks butang lengkapkan",
    previewText: "Teks butang pratonton",
    editText: "Edit teks butang",
    startSurveyText: "Teks butang mulakan",
    showNavigationButtons: "Tunjukkan butang navigasi (navigasi lalai)",
    showPrevButton: "Tunjukkan butang sebelumnya (pengguna boleh kembali ke halaman seterusnya)",
    firstPageIsStarted: "Halaman pertama dalam tinjauan ialah halaman permulaan.",
    showCompletedPage: "Tunjukkan halaman lengkap pada hujung (HTML dilengkapkan)",
    goNextPageAutomatic: "Selepas menjawab semua soalan, pergi ke halaman seterusnya secara automatik",
    showProgressBar: "Tunjukkan bar perkembangan",
    questionTitleLocation: "Lokasi tajuk soalan",
    requiredText: "Soalan memerlukan simbol",
    questionStartIndex: "Indeks mula soalan (1, 2 atau 'A', 'a')",
    showQuestionNumbers: "Tunjukkan nombor soalan",
    questionTitleTemplate: "Templat tajuk soalan, lalai ialah: '{tidak}. {perlukan} {tajuk}'",
    questionErrorLocation: "Lokasi ralat soalan",
    focusFirstQuestionAutomatic: "Fokus soalan pertama pada perubahan halaman",
    questionsOrder: "Susunan elemen pada halaman",
    maxTimeToFinish: "Masa maksimum untuk menyelesaikan tinjauan",
    maxTimeToFinishPage: "Masa maksimum untuk menyelesaikan halaman dalam tinjauan",
    showTimerPanel: "Tunjukkan panel pemasa",
    showTimerPanelMode: "Tunjukkan mod panel pemasa",
    renderMode: "Mod penyampaian",
    allowAddPanel: "Benarkan menambahkan panel",
    allowRemovePanel: "Benarkan alih keluar panel",
    panelAddText: "Menambahkan teks panel",
    panelRemoveText: "Mengalih keluar teks panel",
    isSinglePage: "Tunjukkan semua elemen pada satu halaman",
    html: "HTML",
    expression: "Ekspresi",
    minValue: "Nilai minimum",
    maxValue: "Nilai maksimum",
    minLength: "Panjang minimum",
    allowDigits: "Benarkan digit",
    minCount: "Bilangan minimum",
    maxCount: "Bilangan maksimum",
    regex: "Ekspresi biasa",
    totalText: "Jumlah teks",
    totalType: "Jumlah jenis",
    totalExpression: "Jumlah ekspresi",
    totalDisplayStyle: "Jumlah gaya paparan",
    totalCurrency: "Jumlah mata wang",
    totalFormat: "Jumlah format",
    logoPosition: "Kedudukan logo",
    addLogo: "Tambahkan logo...",
    changeLogo: "Ubah logo...",
    logoPositions: {
      none: "Alih keluar logo",
      left: "Kiri",
      right: "Kanan",
      top: "Di atas",
      bottom: "Di bawah"
    },
    tabs: {
      general: "Umum",
      fileOptions: "Pilihan",
      html: "Editor HTML",
      columns: "Lajur",
      rows: "Baris",
      choices: "Pilihan",
      items: "Item",
      visibleIf: "Boleh Dilihat Jika",
      enableIf: "Dayakan Jika",
      requiredIf: "Diperlukan Jika",
      rateValues: "Nilai Kadar",
      choicesByUrl: "Pilihan daripada Web",
      matrixChoices: "Pilihan Lalai",
      multipleTextItems: "Input Teks",
      numbering: "Nombor",
      validators: "Pengesah",
      navigation: "Navigasi",
      question: "Soalan",
      pages: "Halaman",
      completedHtml: "HTML Dilengkapkan",
      completedHtmlOnCondition: "HTML Dilengkapkan dengan Syarat",
      loadingHtml: "Memuatkan HTML",
      timer: "Pemasa/Kuiz",
      calculatedValues: "Nilai Dikira",
      triggers: "Pencetus",
      templateTitle: "Tajuk templat",
      totals: "Jumlah",
      logic: "Logik",
      layout: "Tataletak",
      data: "Data",
      validation: "Pengesahan",
      cells: "Sel",
      showOnCompleted: "Tunjukkan pada Dilengkapkan",
      logo: "Logo dalam Tajuk Tinjauan",
      slider: "Penggelongsor",
      others: "Lain-lain"
    },
    editProperty: "Edit ciri '{0}'",
    items: "[ Item: {0} ]",
    enterNewValue: "Sila masukkan nilai.",
    noquestions: "Tiada soalan lain dalam tinjauan.",
    createtrigger: "Sila cipta pencetus",
    titleKeyboardAdornerTip: "Tekan butang enter untuk mengedit",
    keyboardAdornerTip: "Tekan butang enter untuk mengedit item, tekan butang padam untuk memadamkan item, tekan butang alt dan anak panah ke atas atau ke bawah untuk menggerakkan item",
    keyboardMoveItemsTip: "Tekan butang alt dan anak panah ke atas atau ke bawah untuk menggerakkan item",
    triggerOn: "Hidup ",
    triggerMakePagesVisible: "Jadikan halaman boleh dilihat:",
    triggerMakeQuestionsVisible: "Buat elemen boleh dilihat:",
    triggerCompleteText: "Lengkapkan tinjauan jika berjaya.",
    triggerNotSet: "Pencetus tidak ditetapkan",
    triggerRunIf: "Jalankan jika",
    triggerSetToName: "Ubah nilai: ",
    triggerFromName: "Salin nilai daripada: ",
    triggerRunExpression: "Jalankan Ekspresi ini:",
    triggerSetValue: "kepada: ",
    triggerGotoName: "Pergi kepada soalan:",
    triggerIsVariable: "Jangan letakkan pemboleh ubah dalam keputusan tinjauan.",
    triggerRunExpressionEmpty: "Sila masukkan ekspresi yang sah",
    noFile: "Tiada fail dipilih"
  },
  pv: {
    true: "benar",
    false: "palsu",
    inherit: "warisi",
    show: "tunjukkan",
    hide: "sembunyikan",
    default: "lalai",
    initial: "awal",
    random: "rawak",
    collapsed: "kuncup",
    expanded: "kembang",
    none: "tiada",
    asc: "tertib menaik",
    desc: "menurun",
    indeterminate: "tidak tentu",
    decimal: "perpuluhan",
    currency: "mata wang",
    percent: "peratus",
    firstExpanded: "Pertama dikembangkan",
    off: "mati",
    onPanel: "Pada panel",
    onSurvey: "Pada tinjauan",
    list: "senarai",
    progressTop: "Perkembangan atas",
    progressBottom: "Perkembangan bawah",
    progressTopBottom: "Perkembangan atas bawah",
    horizontal: "mendatar",
    vertical: "menegak",
    top: "atas",
    bottom: "bawah",
    topBottom: "atas dan bawah",
    both: "kedua-duanya",
    left: "baki",
    color: "warna",
    date: "tarikh",
    datetime: "Tarikh masa",
    "datetime-local": "Tarikh masa-tempatan",
    email: "e-mel",
    month: "bulan",
    number: "nombor",
    password: "kata laluan",
    range: "julat",
    tel: "tel",
    text: "teks",
    time: "masa",
    url: "URL",
    week: "minggu",
    hidden: "tersembunyi",
    on: "pada",
    onPage: "Pada halaman",
    edit: "edit",
    display: "paparan",
    onComplete: "Pada selesai",
    onHidden: "Pada tersembunyi",
    all: "semua",
    page: "halaman",
    survey: "tinjauan",
    onNextPage: "Pada halaman berikutnya",
    onValueChanged: "Pada nilai berubah",
    singlePage: "halaman tunggal",
    standard: "standard",
    questionPerPage: "soalan bagi setiap halaman",
    noPreview: "tiada pratonton",
    showAllQuestions: "tunjukkan pratonton dengan semua soalan",
    showAnsweredQuestions: "tunjukkan pratonton dengan soalan dijawab",
    pages: "halaman",
    questions: "soalan",
    requiredQuestions: "soalan diperlukan",
    correctQuestions: "soalan betul",
    buttons: "butang",
    underInput: "input di bawah",
    underTitle: "tajuk di bawah"
  },
  op: {
    empty: "kosong",
    notempty: "tidak kosong",
    equal: "sama dengan",
    notequal: "tidak sama dengan",
    contains: "mengandungi",
    notcontains: "tidak mengandungi",
    anyof: "sebarang",
    allof: "semua",
    greater: "lebih besar",
    less: "kurang",
    greaterorequal: "lebih besar atau sama dengan",
    lessorequal: "kurang atau sama dengan",
    and: "dan",
    or: "atau"
  },
  ew: {
    angular: "Guna versi Angular",
    jquery: "Guna versi jQuery",
    knockout: "Guna versi Knockout",
    react: "Guna versi React",
    vue: "Guna versi Vue",
    bootstrap: "Untuk kerangka kerja butstrap",
    modern: "Tema moden",
    default: "Tema lalai",
    orange: "Tema oren",
    darkblue: "Tema biru gelap",
    darkrose: "Tema mawar gelap",
    stone: "Tema batu",
    winter: "Tema musim sejuk",
    winterstone: "Tema batu-musim sejuk",
    showOnPage: "Tunjukkan tinjauan pada halaman",
    showInWindow: "Tunjukkan tinjauan pada tetingkap",
    loadFromServer: "Muatkan Tinjauan JSON daripada pelayan",
    titleScript: "Skrip dan gaya",
    titleHtml: "HTML",
    titleJavaScript: "JavaScript"
  },
  ts: {
    selectPage: "Pilih halaman untuk mengujinya:",
    showInvisibleElements: "Pilih elemen tersembunyi"
  },
  validators: {
    answercountvalidator: "kiraan jawapan",
    emailvalidator: "e-mel",
    expressionvalidator: "ekspresi",
    numericvalidator: "numerik",
    regexvalidator: "regex",
    textvalidator: "teks"
  },
  triggers: {
    completetrigger: "lengkapkan tinjauan",
    setvaluetrigger: "tetapkan nilai",
    copyvaluetrigger: "salin nilai",
    skiptrigger: "langkau kepada soalan",
    runexpressiontrigger: "jalankan ekspresi",
    visibletrigger: "ubah kebolehlihatan (tidak digunakan lagi)"
  },
  p: {
    name: "nama",
    title: {
      name: "tajuk",
      title: "Biarkan kosong, jika sama seperti 'Nama'"
    },
    navigationButtonsVisibility: "Kebolehlihatan butang navigasi",
    questionsOrder: "Susunan soalan",
    maxTimeToFinish: "Masa untuk selesai maksimum",
    visible: "Boleh dilihat",
    visibleIf: "Boleh dilihat jika",
    questionTitleLocation: "Lokasi tajuk soalan",
    description: "perihalan",
    state: "negeri",
    isRequired: "Diperlukan",
    requiredIf: "Diperlukan jika",
    indent: "inden",
    requiredErrorText: "Teks ralat diperlukan",
    startWithNewLine: "Mulakan dengan baris baharu",
    innerIndent: "Inden dalaman",
    page: "halaman",
    width: "lebar",
    commentText: "Teks komen",
    valueName: "Nama nilai",
    enableIf: "Dayakan jika",
    defaultValue: "Nilai lalai",
    correctAnswer: "Jawapan betul",
    readOnly: "Baca sahaja",
    validators: "Pengesah",
    titleLocation: "Lokasi tajuk",
    showCommentArea: "Ada komen",
    showOtherItem: "Ada lain",
    choices: "pilihan",
    choicesOrder: "Susunan pilihan",
    choicesByUrl: "Pilihan melalui URL",
    otherText: "Teks lain",
    otherErrorText: "Teks ralat lain",
    storeOthersAsComment: "Simpan lain sebagai komen",
    label: "label",
    showTitle: "Tunjukkan tajuk",
    valueTrue: "Nilai benar",
    valueFalse: "Nilai palsu",
    cols: "lajur",
    rows: "baris",
    placeholder: "Ruang letak",
    optionsCaption: "Kapsyen pilihan",
    expression: "ekspresi",
    format: "format",
    displayStyle: "Paparkan gaya",
    currency: "mata wang",
    useGrouping: "Guna perkumpulan",
    showPreview: "Tunjukkan pratonton",
    allowMultiple: "Benarkan berbilang",
    imageHeight: "Tinggi imej",
    imageWidth: "Lebar imej",
    storeDataAsText: "Simpan data sebagai teks",
    maxSize: "Saiz maks",
    html: "html",
    columns: "lajur",
    cells: "sel",
    isAllRowRequired: "Semua baris diperlukan",
    horizontalScroll: "Tatal mendatar",
    cellType: "Jenis sel",
    columnsLayout: "Tataletak lajur",
    columnColCount: "Lajur bilangan lajur",
    columnMinWidth: "Lebar min lajur",
    rowCount: "Bilangan baris",
    minRowCount: "Bilangan baris min",
    maxRowCount: "Bilangan baris maks",
    keyName: "Nama kunci",
    keyDuplicationError: "Ralat pendua kekunci",
    confirmDelete: "Sahkan padam",
    confirmDeleteText: "Sahkan padamkan teks",
    addRowLocation: "Tambah lokasi baris",
    addRowText: "Tambah teks baris",
    removeRowText: "Alih keluar teks baris",
    items: "item",
    itemSize: "Saiz item",
    colCount: "Bilangan lajur",
    templateTitle: "Tajuk templat",
    templateDescription: "Perihalan templat",
    allowAddPanel: "Benarkan tambahkan panel",
    allowRemovePanel: "Benarkan alih keluar panel",
    panelCount: "Kiraan panel",
    minPanelCount: "Bilangan panel min",
    maxPanelCount: "Bilangan panel maks",
    panelsState: "Keadaan panel",
    panelAddText: "Panel tambah teks",
    panelRemoveText: "Panel alih keluar teks",
    panelPrevText: "Panel teks sebelumnya",
    panelNextText: "Panel teks seterusnya",
    showQuestionNumbers: "Tunjukkan nombor soalan",
    showRangeInProgress: "Tunjukkan julat sedang berjalan",
    renderMode: "Mod penyampaian",
    templateTitleLocation: "Templat lokasi tajuk",
    rateValues: "Kadar nilai",
    rateMin: "Kadar min",
    rateMax: "Kadar maks",
    rateStep: "Kadar langkah",
    minRateDescription: "Perihalan kadar min",
    maxRateDescription: "Perihalan kadar maks",
    inputType: "Jenis input",
    size: "saiz",
    locale: "tempatan",
    focusFirstQuestionAutomatic: "Fokus soalan pertama secara automatik",
    completedHtml: "HTML Dilengkapkan",
    completedBeforeHtml: "Lengkapkan sebelum HTML",
    loadingHtml: "Memuatkan HTML",
    triggers: "pencetus",
    cookieName: "Nama kuki",
    sendResultOnPageNext: "Hantar keputusan pada halaman seterusnya",
    showNavigationButtons: "Tunjukkan butang navigasi",
    showPrevButton: "Tunjukkan butang sebelumnya",
    showPageTitles: "Tunjukkan tajuk halaman",
    showCompletedPage: "Tunjukkan halaman dilengkapkan",
    showPageNumbers: "Tunjukkan nombor halaman",
    questionErrorLocation: "Soalan lokasi ralat",
    showProgressBar: "Tunjukkan bar perkembangan",
    mode: "mod",
    goNextPageAutomatic: "Pergi halaman seterusnya automatik",
    checkErrorsMode: "Semak mod ralat",
    clearInvisibleValues: "Kosongkan nilai tersembunyi",
    startSurveyText: "Mulakan teks tinjauan",
    pagePrevText: "Halaman teks sebelumnya",
    pageNextText: "Halaman teks seterusnya",
    completeText: "Lengkapkan teks",
    requiredText: "Teks diperlukan",
    questionStartIndex: "Indeks mula soalan",
    questionTitleTemplate: "Templat tajuk soalan",
    firstPageIsStarted: "Halaman pertama dimulakan",
    isSinglePage: "Ialah halaman tunggal",
    maxTimeToFinishPage: "Masa untuk halaman selesai maks",
    showTimerPanel: "Tunjukkan panel pemasa",
    showTimerPanelMode: "Tunjukkan mod panel pemasa",
    defaultPanelValue: "Nilai panel lalai",
    defaultRowValue: "Nilai baris lalai",
    showNoneItem: "tiada",
    noneText: "Tiada teks",
    text: "teks",
    multiSelect: "Pilih berbilang",
    showLabel: "Tunjukkan label",
    logo: "logo",
    logoWidth: "Lebar logo",
    logoHeight: "Tinggi logo",
    logoFit: "Muat logo",
    focusOnFirstError: "Fokus pada ralat pertama",
    completedHtmlOnCondition: "HTML dilengkapkan dengan syarat",
    pages: "halaman",
    calculatedValues: "Nilai dikira",
    navigateToUrl: "Navigasi ke URL",
    navigateToUrlOnCondition: "Navigasi ke URL dengan syarat",
    questionDescriptionLocation: "Lokasi perihalan soalan",
    progressBarType: "Jenis bar perkembangan",
    maxTextLength: "Panjang teks maks",
    maxOthersLength: "Panjang lain maks",
    textUpdateMode: "Mod kemas kini teks",
    autoGrowComment: "Auto besarkan komen",
    questionTitlePattern: "Corak tajuk soalan",
    questionsOnPageMode: "Soalan pada mod halaman",
    showPreviewBeforeComplete: "Tunjukkan pratonton sebelum dilengkapkan",
    widthMode: "Mod lebar",
    showNumber: "Tunjukkan nombor",
    navigationTitle: "Tajuk navigasi",
    navigationDescription: "Perihalan navigasi",
    useDisplayValuesInDynamicTexts: "Guna nilai paparan dalam tajuk",
    minWidth: "Lebar min",
    maxWidth: "Lebar maks",
    descriptionLocation: "Lokasi perihalan",
    hideNumber: "Sembunyikan nombor",
    defaultValueExpression: "Ekspresi nilai lalai",
    bindings: "ikatan",
    columnsVisibleIf: "Lajur boleh dilihat jika",
    rowsVisibleIf: "Baris boleh dilihat jika",
    showHeader: "Tunjukkan pengepala",
    detailPanelMode: "Butiran mod panel",
    rowTitleWidth: "Lebar tajuk baris",
    allowAddRows: "Benarkan tambahkan baris",
    allowRemoveRows: "Benarkan alih keluar baris",
    defaultValueFromLastRow: "Nilai lalai daripada baris terakhir",
    hideColumnsIfEmpty: "Sembunyikan lajur jika kosong",
    emptyRowsText: "Kosongkan teks baris",
    detailPanelShowOnAdding: "Butiran panel tunjukkan pada penambahan",
    allowRowsDragAndDrop: "Benarkan seret dan lepas baris",
    rowsOrder: "Susunan baris",
    hideIfRowsEmpty: "Sembunyikan jika baris kosong",
    maximumFractionDigits: "Digit pecahan maks",
    minimumFractionDigits: "Digit pecahan minimum",
    choicesFromQuestion: "Pilihan daripada soalan",
    choicesFromQuestionMode: "Pilihan daripada mod soalan",
    hideIfChoicesEmpty: "Sembunyikan jika pilihan kosong",
    choicesVisibleIf: "Pilihan boleh dilihat jika",
    choicesEnableIf: "Pilihan didayakan jika",
    otherPlaceHolder: "Ruang letak lain",
    maxSelectedChoices: "Pilihan dipilih maks",
    showClearButton: "Tunjukkan butang kosongkan",
    contentMode: "Mod kandungan",
    imageFit: "Muat imej",
    autocomplete: "Auto lengkap",
    min: "min",
    max: "maks",
    minValueExpression: "Ekspresi nilai min",
    maxValueExpression: "Ekspresi nilai maks",
    minErrorText: "Teks ralat min",
    maxErrorText: "Teks ralat maks",
    step: "langkah",
    dataList: "Senarai data",
    autoGrow: "Auto besarkan",
    multiLine: "Berbilang baris",
    allowImagesPreview: "Benarkan pratonton imej",
    acceptedTypes: "Jenis diterima",
    waitForUpload: "Tunggu untuk muat naik",
    needConfirmRemoveFile: "Perlu sahkan alih keluar fail",
    labelTrue: "Label benar",
    labelFalse: "Label palsu",
    height: "tinggi",
    allowClear: "Benarkan kosongkan",
    penColor: "Warna pen",
    backgroundColor: "Warna latar belakang",
    dataFormat: "Format data",
    defaultValueFromLastPanel: "Nilai lalai daripada panel terakhir",
    panelRemoveButtonLocation: "Panel lokasi butang alih keluar",
    showCaption: "Tunjukkan kapsyen",
    iconName: "Nama ikon",
    iconSize: "Saiz ikon"
  }
};

editorLocalization.locales["ms"] = msStrings;
